export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id|| "Id No disponible",
    loc_descripcion: item.loc_descripcion || "Descripción no disponible", // Descripción con valor por defecto
    descripcionProvincia: item.localidad_provincia?.pcia_descripcion || "No se encuentra provincia", // Uso del operador optional chaining
    descripcionDepartamento: item.localidad_departamento?.depa_descripcion || "No se encuentra departamento", // Uso del operador optional chaining
    mostrar: item.loc_show_web === 0 ? "Visible": "Oculto" 
  }));
